<template>
  <div class="searchComm">
    <input
      type="text"
      name=""
      id=""
      class="searchInput"
      :placeholder="placeholder"
      :style="[{ width: `${width}px` }]"
      v-model="modelValue"
    />
    <div class="search" @click="searchClick">
      <img src="../assets/channel/Waring/search.png" alt="" />
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  props: {
    placeholder: {
      type: String,
    },
    width: {
      type: Number,
      default: 360,
    },
    modelValue: {
      type: String,
    }
  },
  data() {
    return {
    };
  },
  created() {},
  mounted() {},
  activated() {},
  updated() {},
  methods: {
    searchClick() {
      this.$emit("searchClick", this.modelValue);
    },
  },
  computed: {},
  watch: {},
};
</script>
<style scoped lang="less">
.searchInput {
  width: 360px;
  height: 32px;
  background: #fafbfc;
  border: 1px solid #e6e8eb;
  position: absolute;
  right: 48px;
  top: 15px;
  font-size: 14px;
  padding-left: 12px;
}

input::-webkit-input-placeholder {
  /* WebKit browsers */
  color: #9ca5b8;
}
input:-moz-placeholder {
  /* Mozilla Firefox 4 to 18 */
  color: #9ca5b8;
}
input::-moz-placeholder {
  /* Mozilla Firefox 19+ */
  color: #9ca5b8;
}
input:-ms-input-placeholder {
  /* Internet Explorer 10+ */
  color: #9ca5b8;
}
input:focus {
  transition: all .8s;
  border: 1px solid #e71d43;
}
.search {
  display: inline-block;
  width: 32px;
  height: 34px;
  background: #e71d43;
  border-radius: 0px 2px 2px 0;
  position: absolute;
  right: 16px;
  top: 15px;
  cursor: pointer;
  

  img {
    margin: 27%;
  }
}
</style>
